import theme from 'styles/themes/wikifactory';
import { normalize } from 'styled-normalize';
import { customMedia } from 'styles/utils';

import HelveticaNowRegularWoff2 from 'assets/fonts/HelveticaNowDisplay-Regular.woff2';
import HelveticaNowRegularWoff from 'assets/fonts/HelveticaNowDisplay-Regular.woff';
import HelveticaNowXBoldWoff2 from 'assets/fonts/HelveticaNowDisplay-XBold.woff2';
import HelveticaNowXBoldWoff from 'assets/fonts/HelveticaNowDisplay-XBold.woff';

const globalStyles = `
  /* Normalize rules */
  ${normalize}

  /* Font-face rules */
  /* HelveticaNow-Regular */
  @font-face {
    font-family: ${theme.font.family.primary};
    font-display: auto;
    src: local('HelveticaNowDisplay-Regular'), url("${HelveticaNowRegularWoff2}") format("woff2"),
        url("${HelveticaNowRegularWoff}") format("woff");
    font-weight: ${theme.font.weight.regular};
    font-style: normal;
  }
  /* HelveticaNow-XBold */
  @font-face {
    font-family: ${theme.font.family.primary};
    font-display: auto;
    src: local('HelveticaNowDisplay-XBold'), url("${HelveticaNowXBoldWoff2}") format("woff2"),
        url("${HelveticaNowXBoldWoff}") format("woff");
    font-weight: ${theme.font.weight.xbold};
    font-style: normal;
  }
  /* NEW VIEWER FONTS */
  /* HelveticaNow-Regular */
  @font-face {
    font-family: 'HelveticaNowDisplay';
    font-display: auto;
    src: local('HelveticaNowDisplay-Regular'), url("${HelveticaNowRegularWoff2}") format("woff2"),
        url("${HelveticaNowRegularWoff}") format("woff");
    font-weight: ${theme.font.weight.regular};
    font-style: normal;
  }
  /* HelveticaNow-XBold */
  @font-face {
    font-family: 'HelveticaNowDisplay';
    font-display: auto;
    src: local('HelveticaNowDisplay-XBold'), url("${HelveticaNowXBoldWoff2}") format("woff2"),
        url("${HelveticaNowXBoldWoff}") format("woff");
    font-weight: 900;
    font-style: normal;
  }

  /* Global rules*/
  * {
    margin: 0;
    padding: 0;
    &,
    &:before,
    &:after {
      box-sizing: inherit;
    }
  }
  :focus {
    outline: 0;
  }
  a {
    text-decoration: none;
    color: ${theme.color.primary};
  }
  ul {
    list-style: none;
  }
  strong {
    font-weight: ${theme.font.weight.xbold};
  }
  /* Layout */
  html {
    font-size: 16px;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    scroll-behavior: smooth;
    /* Media queries */
    ${customMedia.lessThan('large')`
      font-size: 14px;
    `}
    ${customMedia.lessThan('medium')`
      font-size: 13px;
    `}
    ${customMedia.lessThan('small')`
      font-size: 12px;
    `}
  }

  body {
    font-family: ${theme.font.family.primary}, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html,
  body {
  /* Media queries */
  ${customMedia.lessThan('large')`
    overflow-x: hidden;
  `}
  }
  html,
  body,
  #app {
    height: 100%;
  }
  #app {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  main {
    flex: 1 0 auto;
  }

  /* Form elements */
  textarea {
    resize: none;
  }
  label {
    font-weight: 400;
    color: ${theme.color.wfGrey500};
  }

  /* placeholder */
  ::placeholder {
    font-family: ${theme.font.family.primary}, sans-serif;
    font-weight: 400;
    color: ${theme.color.wfGrey400};
    text-rendering: geometricPrecision;
  }
  .newCollectionTitle::placeholder {
    font-weight: 600;
    font-size: 17px;
  }

  /* Form styles */
  input, textarea {
    &:not(type[radio]) {
      appearance: none;
    }
    &.inputNoBorder {
      border: none;
    }
    &.lightBorder {
      border: 1px solid ${theme.color.wfGrey100};
    }
  }

  .paragraphSpacing12 > * > * + *:not(button) {
    margin-top: 12px;
  }

  .s-alert-box {
    z-index: 2000000;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
  }
`;

export default globalStyles;
